import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const PRIMARY_GREEN = '#34986C';
// --- List Item Component (Used for both audience and tools sections) ---
const ListItem = ({ title, description, backgroundColor = 'white' }) => {
    return (
        <Box display="flex" alignItems="flex-start" mb={4}>
            {/* Checkmark Icon */}
            <CheckCircleIcon sx={{ 
                color: PRIMARY_GREEN, 
                fontSize: 24, 
                mt: 0.25, 
                mr: 1.5,
                filter: 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.1))',
            }} />
            
            {/* Text Content */}
            <Box>
                <Typography 
                    variant="body1" 
                    sx={{ fontWeight: 700, color: 'grey.900', mb: 0.5 }}
                >
                    {title}
                </Typography>
                <Typography 
                    variant="body2" 
                    sx={{ color: 'grey.700' }}
                >
                    {description}
                </Typography>
            </Box>
        </Box>
    );
};
export default ListItem;